var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrush(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.19 3.5H7.81C4.17 3.5 2 5.67 2 9.31V17.68C2 21.33 4.17 23.5 7.81 23.5H16.18C19.82 23.5 21.99 21.33 21.99 17.69V9.31C22 5.67 19.83 3.5 16.19 3.5ZM10.49 18.22C10.15 18.56 9.7 18.79 9.15 18.86L7.8 19.01C7.06 19.09 6.43 18.46 6.51 17.71L6.66 16.35C6.79 15.14 7.8 14.37 8.87 14.35C8.97 14.34 9.09 14.35 9.2 14.36C9.67 14.42 10.12 14.64 10.5 15.01C10.87 15.38 11.08 15.82 11.14 16.27C11.15 16.38 11.16 16.49 11.16 16.59C11.16 17.21 10.93 17.78 10.49 18.22ZM17.44 9.05C16.72 10.85 15.07 13.21 13.5 14.75C13.27 13.33 12.14 12.21 10.7 12.01C12.24 10.43 14.62 8.76 16.43 8.03C16.75 7.91 17.07 8 17.27 8.2C17.47 8.42 17.57 8.73 17.44 9.05Z",
    fill: "#008AFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrush);
export default __webpack_public_path__ + "static/media/brush.dd93234818b0a03faaab5753a0d1925d.svg";
export { ForwardRef as ReactComponent };